import React from 'react';

interface ErrorMessageProps {
  message: string;
}

export function ErrorMessage({ message }: ErrorMessageProps) {
  return (
    <div className="error-container">
      <p className="error-message">{message}</p>
    </div>
  );
}
